import { dummyApiEndpoints } from '@config/apis/dummy-json/dummy-api-endpoints';
import { createApiConfiguration } from '@fagforbundet/ngx-components';

export const dummyApiConfig = createApiConfiguration<typeof dummyApiEndpoints>({
  baseUrl: 'https://dummyjson.com',
  endpoints: dummyApiEndpoints,
});
